var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHungary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.995188 10.8886C0.352063 12.622 0 14.4967 0 16.4538C0 18.411 0.352063 20.2858 0.995188 22.019L16 23.4103L31.0048 22.019C31.6479 20.2858 32 18.411 32 16.4538C32 14.4967 31.6479 12.622 31.0048 10.8886L16 9.49733L0.995188 10.8886Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.454102C9.12074 0.454102 3.25599 4.7961 0.995361 10.8889H31.005C28.7442 4.7961 22.8796 0.454102 16.0001 0.454102V0.454102Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.4541C22.8796 32.4541 28.7442 28.1121 31.005 22.0193H0.995361C3.25599 28.1121 9.12074 32.4541 16.0001 32.4541V32.4541Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungary);
export default __webpack_public_path__ + "static/media/hungary.844b53e8.svg";
export { ForwardRef as ReactComponent };